import {get} from 'aws-amplify/api';
import {Command, type GetMethod} from '../../Command';
import type {GetMeResponse} from '../../../dto/user/GetMeResponse';

export class GetMeCommand extends Command<GetMethod, GetMeResponse> {
  constructor(extensionVersion?: string) {
    const timeZone = safeResolvedTimeZone();
    super(get, {
      path: `/me`,
      options: {
        queryParams: {
          ...(extensionVersion !== undefined ? {extensionVersion} : undefined),
          ...(timeZone !== undefined ? {timeZone} : undefined),
        },
      },
    });
  }

  async deserialize(output: ReturnType<typeof get>): Promise<GetMeResponse> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<GetMeResponse>);
  }
}

function safeResolvedTimeZone(): string | undefined {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof tz === 'string' && tz.length > 0 ? tz : undefined;
  } catch {
    return undefined;
  }
}
